module.exports = __webpack_public_path__ + "mo/img/swiper_bg09.3791c033.png";